/** 선택형 퀴즈 채점 — 선택 인덱스 집합이 정답 집합과 동일한지 */
export function normalizeQuizChoiceIndices(indices: number[]): number[] {
  return Array.from(new Set(indices.filter((i) => Number.isInteger(i) && i >= 0 && i < 8))).sort((a, b) => a - b);
}

export function isQuizChoiceAnswerCorrect(selected: number[], correct: number[]): boolean {
  const a = normalizeQuizChoiceIndices(selected);
  const b = normalizeQuizChoiceIndices(correct);
  if (b.length === 0) return false;
  if (a.length !== b.length) return false;
  return a.every((v, i) => v === b[i]);
}
